import { FC, useCallback, useEffect, useRef, useState } from 'react'
import Head from './components/Head'
import Menu from './components/Menu'
import { getUserInfo } from '@/utils/common'
import env from '@/config/env'
import Workbench from '@/pages/Workbench'
import Tbqy from '@/pages/Tbqy'
import Bmjy from '@/pages/Bmjy'
import styles from './style.module.less'

const BaseLayout: FC = () => {
  const [page, setPage] = useState('')
  const [menuData, setMenuData] = useState([])
  const [breadName, setBreadName] = useState('')
  const frameRef = useRef<HTMLIFrameElement>()
  const [topMenu, setTopMenu] = useState('')

  const handleMenuChange = useCallback((menu) => {
    setBreadName(menu.name || '')
    if(menu.path) {
      let path: string = menu.path.replace(/^\//, '')
      if(!path.startsWith('old/') && !path.startsWith('xmk/')) {
        path = 'old/' + path
      }
      setPage(env.publishHost.replace(/\/$/, '') + '/' + path)
      setTopMenu('')
    }
  }, [])

  useEffect(() => {
    const messageCall = (e) => {
      if(!frameRef.current) {
        return
      }
      const data = JSON.parse(e.data)
      if(data.action === "getLoginUserInfo") {
        const userInfo = getUserInfo()
        e.source.postMessage(JSON.stringify({
          action: 'getLoginUserInfoBack',
          data: userInfo
        }), '*');
      } else if(data.action === "getMenuData") {
        e.source.postMessage(JSON.stringify({
          action: 'getMenuDataBack',
          data: menuData
        }), '*')
      }
    }
    window.addEventListener('message', messageCall)
    return () => {
      window.removeEventListener('message', messageCall)
    }
    
  }, [menuData])

  const handleTopMenu = useCallback((m) => {
    setTopMenu(m.key)
    setPage('')
  }, [])

  useEffect(() => {
    window.openInnerPage = (path, name) => {
      handleMenuChange({name, path})
    }
  }, [handleMenuChange])

  return (
    <div className='flex flex-column h-full'>
      <Head onTopMenu={handleTopMenu} />
      <div className='flex-1 h-0 flex'>
        <Menu onChange={handleMenuChange} onMenuDataChange={setMenuData} />
        <div className='flex-1 w-0 h-full flex flex-column'>
          {
            !page && (
              <div className='flex-1 h-0 p-10 overflow-auto'>
                {
                  topMenu === 'workbench' && <Workbench />
                }
                {
                  topMenu === 'tbqy' && <Tbqy />
                }
                {
                  topMenu === 'bmjy' && <Bmjy />
                }
              </div>
            )
          }
          {
            page && (
              <>
                <div className={styles.bread}>{breadName}</div>
                <div className='flex-1 h-0 overflow-hidden'>
                  <iframe ref={frameRef} src={page} width="100%" height="100%" title="page" frameBorder="no" marginWidth={0} marginHeight={0} scrolling="no" />
                </div>
              </>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default BaseLayout
